module.exports = __webpack_public_path__ + "img/farm--icon--gray.def5077d.svg";